module.exports = __webpack_public_path__ + "static/img/outfire.59736ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/AboutUs/outfire.jpg
// module id = YRai
// module chunks = 12